import { inject, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { environment } from '@environment';
import { VariablesService } from '@services/variables/variables.service';

@Component({
  selector: 'testing',
  standalone: true,
  imports: [CommonModule, YouTubePlayerModule],
  templateUrl: './testing.component.html',
  styleUrls: ['./testing.component.scss']
})
export class TestingComponent {

  readonly vars = inject(VariablesService);

  player;

  ngOnInit() {
    const list = [];
    if (environment.production && this.vars.isBrowser && list.length) {
      const pos = Math.floor(Math.random() * list.length);
      const setAnyOne = list[pos];
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
      window['onYouTubeIframeAPIReady'] = () => this.onYouTubeIframeAPIReady(setAnyOne);
    }
  }


  onYouTubeIframeAPIReady(id) {
    this.player = new YT.Player('test-player', {
      width: '100px',
      height: '60px',
      playerVars: { autoplay: 0, rel: 0, controls: 1, modestbranding: 1, iv_load_policy: 3, showinfo: 0, loop: 0 },
      videoId: id,
      events: {
        'onReady': this.onPlayerReady.bind(this),
        'onStateChange': this.onPlayerStateChange.bind(this)
      }
    });
  }

  onPlayerReady() {
    setTimeout(() => {
      this.player.playVideo();
      this.player.mute();
    }, 100);
  }

  onPlayerStateChange(event) {
    // console.log(event);
  }

}